import { last } from 'lodash'

export const stripTimezone = (date: string) => {
  if (last(date)?.toLowerCase() === 'z') {
    return date.slice(0, -1)
  }

  return date
}
